export default class HeroText {
  constructor(component) {
    this.dom = {
      $component: component,
      $link: component.querySelector('.js-link')
    }
    this.state = {

    }
    this.redirectHandler = this.redirect.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {dom} = this
    dom.$component.addEventListener('click', this.redirectHandler)
  }

  redirect() {
    const {dom} = this

    if (dom.$link) {
      window.location.href = dom.$link.href
    }
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.HeroText = this
  }
}
